import { X, ZoomOut } from "lucide-react";

export const AttendanceImagePreview = ({ imageUrl, title, onClose }) => (
  <div className="attendance-preview-backdrop" role="dialog" aria-modal="true" aria-label={`Pratinjau ${title}`} data-testid="attendance-image-preview" onClick={onClose}>
    <div className="attendance-preview-panel" onClick={(event) => event.stopPropagation()}>
      <div><span><ZoomOut size={16} /> Cubit layar untuk memperbesar</span><button type="button" onClick={onClose} aria-label="Tutup pratinjau gambar" data-testid="attendance-image-preview-close"><X size={20} /></button></div>
      <img src={imageUrl} alt={title} data-testid="attendance-image-preview-content" />
    </div>
  </div>
);